<template>
  <div>
    <div class="position-relative mb-3">
      <div class="position-relative mb-3">
        <section class="section-profile-cover section-shaped my-0">
          <div
            class="shape shape-style-1 bg-gradient-darkgray shape-skew alpha-4"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </section>
        <section class="section-skew">
          <div class="container-section">
            <card shadow class="section-home">
              <div class="row row-grid align-items-center">
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
                >
                  <div class="title-product">
                    <h3>
                      مدیریت فروشگاه آنلاین و فیزیکی
                    </h3>

                    <p>
                      در دنیای دیجیتال امروز، راه‌اندازی یک فروشگاه آنلاین موفق
                      می‌تواند تحولی بزرگ در کسب‌وکار شما ایجاد کند. نرم‌افزار
                      فروشگاه آنلاین سرمد، ابزاری جامع و کاربرپسند است که به شما
                      امکان می‌دهد تا به‌ آسانی فروشگاه اینترنتی خود را ایجاد و
                      مدیریت کنید و تجربه‌ای بی‌نظیر برای مشتریان خود فراهم
                      آورید.
                    </p>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="img-main-page">
                    <img src="img/product/shopping-bro.svg" alt="" />
                  </div>
                </div>
              </div>
            </card>
          </div>
        </section>
      </div>
      <section class="section-tab-product">
        <div class="container-section">
          <tabs :fill="false" class="flex-column">
            <tab-pane key="tab1" class="section-product">
              <template slot="title">
                <h5>
                  مزایای استفاده از سامانه مدیریت فروشگاه
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <ul class="list-unstyled  list-tab mt-4">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          رابط کاربری ساده و جذاب
                        </h5>
                      </div>
                      <p class="pt-2">
                        طراحی کاربرپسند و واکنش‌گرا که تجربه‌ای بی‌نظیر برای
                        مشتریان فراهم می‌کند.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          دسترسی بیست و چهار ساعته
                        </h5>
                      </div>
                      <p class="pt-2">
                        مشتریان شما می‌توانند در هر زمان و مکانی به محصولات شما
                        دسترسی داشته باشند.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          کاهش هزینه‌های عملیاتی
                        </h5>
                      </div>
                      <p class="pt-2">
                        با اتوماسیون حداکثری فرایندها، هزینه‌های مربوط به
                        استخدام نیروی انسانی را کاهش می‌دهد.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          گسترش چشمگیر بازار
                        </h5>
                      </div>
                      <p class="pt-2">
                        امکان دسترسی به مشتریان جدید در سراسر کشور را فراهم
                        می‌کند.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          بهبود خدمات و افزایش رضایت مشتری
                        </h5>
                      </div>
                      <p class="pt-2">
                        با افزایش کیفیت و سرعت ارائه خدمات، رضایت و وفاداری
                        مشتریان را افزایش دهید.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          سفارشی‌سازی آسان و متناسب با نیازهای شما
                        </h5>
                      </div>
                      <p class="pt-2">
                        امکان تغییر و به‌روزرسانی سریع فروشگاه براساس نیازهای
                        بازار و مشتریان وجود دارد.
                      </p>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </tab-pane>
            <tab-pane key="tab2" class="section-product">
              <template slot="title">
                <h5>
                  ویژگی‌های سامانه فروشگاه آنلاین سرمد
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <ul class="list-unstyled  list-tab mt-4">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          انبارداری و مدیریت موجودی
                        </h5>
                      </div>
                      <p class="pt-2">
                        کنترل دقیق موجودی کالاها و به‌روزرسانی آن‌ها به‌ صورت
                        خودکار
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          پرداخت امن و آسان
                        </h5>
                      </div>
                      <p class="pt-2">
                        پشتیبانی از انواع روش‌های پرداخت آنلاین و امن برای جلب
                        اعتماد مشتریان
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          گزارش‌دهی پیشرفته و تحلیل داده‌ها
                        </h5>
                      </div>
                      <p class="pt-2">
                        ارائه گزارش‌های جامع بازدید، فروش و تحلیل رفتار مشتریان
                        برای بهبود استراتژی‌های بازاریابی
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          سئوی پیشرفته
                        </h5>
                      </div>
                      <p class="pt-2">
                        بهینه‌سازی فروشگاه برای موتورهای جستجو به منظور افزایش
                        ترافیک و جذب مشتریان بیشتر
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          مدیریت استعلام‌ها و سفارش‌ها
                        </h5>
                      </div>
                      <p class="pt-2">
                        دسترسی به تمامی اطلاعات مربوط به استعلام‌ها و سفارش‌های
                        ثبت شده، از جمله وضعیت، تاریخ و جزئیات بیشتر آن‌ها
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          مدیریت ابزارهای بازاریابی
                        </h5>
                      </div>
                      <p class="pt-2">
                        امکاناتی برای ایجاد تخفیف‌ها، پیشنهادهای ویژه و
                        کمپین‌های تبلیغاتی
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          مدیریت کاربران
                        </h5>
                      </div>
                      <p class="pt-2">
                        تخصیص پروفایل شخصی به کاربران و امکان دسترسی و مدیریت
                        اطلاعات هر پروفایل و تاریخچه سفارش‌ها
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          سیستم پشتیبانی از طریق تیکت یا چت
                        </h5>
                      </div>
                      <p class="pt-2">
                        امکان ارائه خدمات پشتیبانی به مشتریان شما از طریق تولید
                        و پاسخگویی به تیکت یا چت real-time
                      </p>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </tab-pane>
          </tabs>
        </div>
      </section>
    </div>
    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";

export default {
  name: "Onlion",
  components: {
    Tabs,
    TabPane,
  },
  data() {
    return {
      showScrollButton: false,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
